import { SurveyPublisher } from './surveypublisher.model';
import { SectionViewModel } from './sectionview.model';
import { UserActivityLogModel } from './userActivityLog.model';

export class SurveyViewModel {
    public surveyId: string;
    public name: string;
    public status: string;
    public description: string;
    public resultsCount: number;
    public isFavourite: boolean = false;
    public isEsignReq : Boolean=false;
    public isLiked: boolean = false;
    public categoryName: string;
    public surveyType: string;
    public logoFormat: string;
    public logoImage: string;
    public surveyAdmins:SurveyPublisher[];
    public userId: string;
    public sections: SectionViewModel[];
    public  isWorkflow:boolean=false;
    public dueDaysCount:number;
    public redirectionUrl: string;
    public userActivityLog? : UserActivityLogModel;
}